mutation resendHoppermationSenderValidation($senderId: ID!) {
  resendHoppermationSenderValidation(senderId: $senderId)
}
